import React, { useState } from "react";
import { utils } from "../../../utils/utils";
import { Container, Button } from "reactstrap";
import SequencesTable from "./SequencesTable";
import { useAuth } from "../../../providers/authProvider";
import InformationModal from "../../InformationModal";
import ConfirmationModal from "../../ConfirmationModal";
import SequenceDetailsModal from "./SequenceDetailsModal";
import { sequenceApi } from "../../../services/sequenceServices";

const WAITING_FOR_DETAILER_STATUS = 2;
const DETAILING_IN_PROGRESS_STATUS = 3;
const WAITING_FOR_DETAILING_TAB = "WAITING_FOR_DETAILING_TAB";

const WaitingForDetailing = ({
  sequencesTotal,
  setSequencesTotal,
  setReloadTabs,
  reloadTabs,
  tabName,
  search = "",
}) => {
  const [authContext] = useAuth();
  const userId = authContext?.currentUser?.id;
  const [sequenceStatusId, setSequenceStatusId] = useState();
  const [sequenceSelected, setSequenceSelected] = useState();
  const [checkerId, setCheckerId] = useState();
  const [detailerId, setDetailerId] = useState();
  const [detailModal, setDetailModal] = useState(false);
  const [informationModal, setInformationModal] = useState(
    utils.initInformationModal
  );
  const [confirmationModal, setConfirmationModal] = useState(
    utils.initConfirmationModal
  );
  const canUpdateDetailModal =
    utils.canUserPerformDetailingAction(
      sequenceSelected,
      sequenceStatusId,
      userId
    ) || utils.isAdminRole(authContext.currentUser?.role?.id);
  const columns = [
    {
      accessor: "startDetailing",
      Header: "",
      headerProps: { className: "text-truncate" },
      disableSortBy: true,
      width: 120,
      Cell: (rowData) => {
        const sequence = rowData.row.original;
        const canPerform =
          utils.canUserPerformDetailingAction(
            sequence,
            WAITING_FOR_DETAILER_STATUS,
            userId
          ) || utils.isAdminRole(authContext.currentUser?.role?.id);
        if (!canPerform) return null;
        return (
          <Button
            className="btn-sm rounded px-1 py-0"
            color={"success"}
            onClick={() => {
              const sequence = rowData.row.original;
              changeSequenceStatus(
                sequence,
                DETAILING_IN_PROGRESS_STATUS,
                sequence?.detailer?.id ?? null,
                sequence?.checker?.id ?? null
              );
            }}
          >
            Start Detailing
          </Button>
        );
      },
    },
    {
      accessor: "seeJobDetailsButton",
      Header: "Job Details",
      headerProps: { className: "text-truncate" },
      disableSortBy: true,
      width: 125,
      Cell: (rowData) => {
        const sequence = rowData.row.original;
        return (
          <Button
            className="btn-sm rounded px-1 py-0"
            color={"primary"}
            onClick={() => {
              setSequenceSelected(sequence);
              setSequenceStatusId(sequence.sequenceStatusId);
              setDetailerId(sequence?.detailer?.id || null);
              setCheckerId(sequence?.checker?.id || null);
              setDetailModal(true);
            }}
          >
            See Job Details
          </Button>
        );
      },
    },
  ];

  const onClear = async () => {
    setConfirmationModal(utils.initConfirmationModal);
    setInformationModal(utils.initInformationModal);
    setDetailerId();
    setCheckerId();
    setDetailModal(false);
    setSequenceSelected();
    setSequenceStatusId();
  };

  const changeSequenceStatus = async (
    sequence,
    sequenceStatusId,
    effectiveDetailerId = detailerId,
    effectiveCheckerId = checkerId
  ) => {
    try {
      const startDetailing = sequenceStatusId === DETAILING_IN_PROGRESS_STATUS;
      setConfirmationModal({
        isOpen: true,
        onSubmit: async () => {
          try {
            const { detailer, checker, ...sequenceFields } = sequence;
            await sequenceApi.updateSequence(sequence.id, {
              ...sequenceFields,
              detailerId: effectiveDetailerId,
              checkerId: effectiveCheckerId,
              sequenceStatusId,
            });
            onClear();
            setInformationModal({
              isOpen: true,
              title: startDetailing ? "Start Detailing" : "Sequence Update",
              body: startDetailing
                ? "Detailing started successfully."
                : "Sequence updated successfully.",
            });
            setReloadTabs([
              WAITING_FOR_DETAILING_TAB,
              utils.detailingTabs[sequenceStatusId],
            ]);
          } catch (error) {
            onClear();
            setInformationModal({
              isOpen: true,
              title: "Error",
              body: "There was an error with your request.",
            });
          }
        },
        onClose: () => setConfirmationModal(utils.initConfirmationModal),
        title: startDetailing ? "Start Detailing" : "Sequence Update",
        body: startDetailing
          ? `
          <div class="text-center">
            Are you sure you are ready to begin detailing this job?
          </div>
        `
          : `
        <div class="text-center">
          Do you confirm you want to update the sequence ${sequence.job.jobNumber}?
        </div>
      `,
        confirmColor: "warning",
      });
    } catch (error) {
      setInformationModal({
        isOpen: true,
        title: "Error",
        body: "There was an error with your request.",
      });
    }
  };

  const onSubmit = (e) => {
    e.preventDefault();
    changeSequenceStatus(
      sequenceSelected,
      sequenceStatusId,
      detailerId,
      checkerId
    );
  };

  return (
    <Container fluid className="px-0">
      <SequencesTable
        columns={columns}
        sequenceStatusId={WAITING_FOR_DETAILER_STATUS}
        setSequencesTotal={setSequencesTotal}
        sequencesTotal={sequencesTotal}
        reloadTabs={reloadTabs}
        tabName={tabName}
        search={search}
      />
      {informationModal.isOpen ? (
        <InformationModal
          title={informationModal.title}
          body={informationModal.body}
          onClose={() => setInformationModal(utils.initInformationModal)}
        />
      ) : confirmationModal.isOpen ? (
        <ConfirmationModal {...confirmationModal} />
      ) : detailModal ? (
        <SequenceDetailsModal
          sequence={sequenceSelected}
          detailModal={detailModal}
          onSubmit={onSubmit}
          onClear={onClear}
          checkerId={checkerId}
          setCheckerId={setCheckerId}
          detailerId={detailerId}
          setDetailerId={setDetailerId}
          enableUpdate={canUpdateDetailModal}
          statusId={sequenceStatusId}
          setStatusId={setSequenceStatusId}
        />
      ) : null}
    </Container>
  );
};

export default WaitingForDetailing;
